import { z } from 'zod'
import type { Hex, LowerHex } from '../../types'
import type { LogWithBlockNumber } from '../types'
import type { KaiascanOapiClient } from './oapiClient'
import { kaiascanOapiLogSchema } from './schema'

type GetEventLogsByAddressAndTopicParameters = {
  client: KaiascanOapiClient
  address: Hex
  topic0: LowerHex
  fromBlock?: number
  toBlock?: number
  page?: number
  size?: number
  headers?: Record<string, string>
}

const resultSchema = z.object({
  results: z.array(kaiascanOapiLogSchema),
})

/**
 * Kaiascan OAPI から address と topic0 に一致する event log を取得する。
 *
 * @param parameters - client、address、topic0、block range、pagination、headers。
 * @returns block number 付き log の配列。
 */
export const getEventLogsByAddressAndTopic = async ({
  client,
  address,
  topic0,
  fromBlock = 0,
  toBlock,
  page = 1,
  size = 500,
  headers,
}: GetEventLogsByAddressAndTopicParameters): Promise<LogWithBlockNumber[]> => {
  const result = await client.get({
    path: `/api/v1/accounts/${address}/event-logs`,
    query: {
      signature: topic0,
      blockNumberStart: fromBlock.toString(),
      ...(toBlock === undefined ? {} : { blockNumberEnd: toBlock.toString() }),
      page: page.toString(),
      size: size.toString(),
    },
    resultSchema,
    headers,
  })
  return result.results.map((log) => ({
    address: log.contract_address,
    blockNumber: log.block_number,
    data: log.data,
    logIndex: log.log_index,
    topics: log.topics,
    transactionHash: log.transaction_hash,
  }))
}
